import type { GameState, Move, Transition } from "./model";
import { applyCanonicalLegalMove } from "./transition";

/**
 * Fast successor path for engine-internal search.
 *
 * Preconditions: `state` is a canonical state produced by this engine and
 * `move` is an object returned by legal-move generation for that exact state.
 * No validation or legality lookup is performed. UI, persistence, and other
 * untrusted boundaries must use `applyMove` instead.
 *
 * This module is intentionally omitted from the public `src/game/index.ts`
 * barrel. Search code imports it explicitly from `game/searchTransition`.
 */
export function applyGeneratedMove(state: GameState, move: Move): Transition {
  return applyCanonicalLegalMove(state, move);
}
